/**
 * `cn` — the class-name merger every shadcn component expects.
 *
 * `clsx` resolves conditionals into a string; `tailwind-merge` then drops
 * earlier utilities that a later one overrides, so a caller's `className` wins
 * over a component's defaults instead of losing a specificity coin-toss.
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: readonly ClassValue[]): string {
  return twMerge(clsx(inputs));
}
